import { ITipoAtividades } from "../../Interfaces/Geral/TipoAtividades";
import Axios from "../Config/API";
import Service from "../Service";

export async function listarTipoAtividadesService() {
    return Service(
        Axios.get<Array<ITipoAtividades>>(
            `/home/tipoatividade/listartipoatividade`
        )
    );
}

export async function DeletarTipoAtividadesService(ID_TIPO_ATIVIDADE: number) {
    return Service(
        Axios.delete<Array<ITipoAtividades>>(
            `/home/tipoatividade/deletartipoatividade?ID_TIPO_ATIVIDADE=${ID_TIPO_ATIVIDADE}`
        )
    );
}

export async function UptadeTipoAtividadesService(
    requestBody: ITipoAtividades
) {
    return Service(
        Axios.put<Array<ITipoAtividades>>(
            `/home/tipoatividade/atualizartipoatividade`,
            requestBody
        )
    );
}

export async function InserirTipoAtividadesService(
    requestBody: ITipoAtividades
) {
    return Service(
        Axios.post<Array<ITipoAtividades>>(
            `/home/tipoatividade/inserirtipoatividade`,
            requestBody
        )
    );
}
